import { Popover } from "antd";
import { PopoverProps } from "./type";

function AntPopOver(props: PopoverProps) {
  return <Popover {...props} />;
}

export { AntPopOver as Popover };
